import { Alert, AlertDescription, AlertIcon, Box, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useGetFrameworkAgreementQuery } from "../../../autogen/bff-api";
import { isNoAccessError } from "../../../common/errors/isNoAccessError";

export const FrameworkCeilingExceeded = ({ frameworkAgreementId }: { frameworkAgreementId: string }) => {
  const { t } = useTranslation();
  const { data: framework, error, isError, refetch } = useGetFrameworkAgreementQuery(
    { frameworkAgreementId },
    { refetchOnMountOrArgChange: true },
  );

  if (isError && !isNoAccessError(error)) {
    return (
      <Alert status="warning" rounded="md" mt="3" fontSize="sm" alignItems="flex-start">
        <AlertIcon />
        <Box>
          <AlertDescription>
            {t("Could not check whether the call-offs exceed the framework agreement's ceiling value.")}
          </AlertDescription>
          <Button mt="2" size="xs" variant="outline" onClick={() => void refetch()}>
            {t("Try again")}
          </Button>
        </Box>
      </Alert>
    );
  }

  const remaining = framework?.summary.remainingCeilingValue;
  if (remaining == null || Number(remaining) >= 0) return null;

  return (
    <Alert status="warning" rounded="md" mt="3" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      <AlertDescription>
        {t(
          "The call-offs under this framework agreement now add up to more than its ceiling value. No further call-offs can be made under it, and what exceeds the ceiling value must be handled, for example with a new competition.",
        )}
      </AlertDescription>
    </Alert>
  );
};
